'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps"];
import * as React from 'react';
import { useStore } from '@mui/x-internals/store';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChatStore } from "../hooks/useChatStore.js";
import { chatSelectors } from "../selectors/index.js";
import { useComposerContext } from "./internals/ComposerContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerAttachmentList = /*#__PURE__*/React.forwardRef(function ComposerAttachmentList(props, ref) {
  const {
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const composer = useComposerContext();
  // Read attachments from the store (the source of truth) rather than the
  // ComposerContext. The default attachment-list content is store-backed, so
  // gating on the store lets the list render in a standalone/custom-layout
  // preview where there is no `ChatComposer` ancestor (the ComposerContext
  // default would report zero attachments and the list would never mount).
  const store = useChatStore();
  const attachments = useStore(store, chatSelectors.composerAttachments);
  const ownerState = {
    isSubmitting: composer.isSubmitting,
    hasValue: composer.hasValue,
    isStreaming: composer.isStreaming,
    attachmentCount: attachments.length,
    disabled: composer.disabled
  };
  const AttachmentList = slots?.attachmentList ?? 'div';
  const rootProps = useSlotProps({
    elementType: AttachmentList,
    externalSlotProps: slotProps?.attachmentList,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  if (attachments.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(AttachmentList, _extends({}, rootProps));
});
if (process.env.NODE_ENV !== "production") ComposerAttachmentList.displayName = "ComposerAttachmentList";